import omit from 'lodash/omit';

function getMappedUserProperties(userProperties) {
  const subStatus = userProperties?.userInfo?.subscriptionStatus;
  return {
    ...omit(userProperties.userInfo, ['username', 'subscriptionStatus']), // Info like email, etc
    userName: userProperties?.userInfo?.username, // For consistency, so kill 'username' like above
    ...(subStatus && { subscriptionStatus: subStatus.toLowerCase() }),
    ...userProperties.profile,
  };
}

export default function mapProfileDetails(userProfile) {
  const userProperties = userProfile.properties;

  return {
    accountId: userProfile.guideId,
    id: userProperties.userInfo.username,
    actions: userProfile.actions,
    image: userProfile.image,
    bannerImage: userProfile.bannerImage,
    title: userProfile.title,
    subtitle: userProfile.subtitle,
    ...getMappedUserProperties(userProperties),
  };
}

/*
example response info
{
  "Item": {
    "GuideId": "u207200",
    "Image": "https://graph.facebook.com/v2.6/872998053432/picture?width=300&height=300",
    "Title": "Nadine Kinnen",
    "Subtitle": "33d3289d",
    "Actions": {
      ...data for profile page
    },
    "Properties": {
      "UserInfo": {
        "Username": "33d3289d",
        "Email": "",
        "IsOnboarded": false,
        "SubscriptionStatus": "Active",
        "SubscriptionExpiresOn": "2020-02-08T21:57:06",
        "SubscriptionProviderId": 11,
        "SubscriptionProviderName": "recurly",
        "SubscriptionKey": "4a3db18e39465f16cea47641bcad3da3",
        "SubscriptionAccessRestricted": false,
        "HasProfileOwnership": false,
        "IsRegisteredUser": true,
        "IsVerifiedUser": false
      },
      "Profile": {
        "IsProfileVerified": false,
        "IsFollowingListPublic": true
      },
    },
  },
}
*/
